import React from "react";
import ReactDatePicker, { registerLocale } from "react-datepicker";
import pt from "date-fns/locale/pt";
import style from "./style.module.css";
import IcX from "../../components/Svg/IcX";
import { PatternFormat } from "react-number-format";
import Tooltip2 from "../Tooltip";

export default function DatePicker(props) {
  registerLocale("pt", pt);
  const {
    selected,
    changeDate,
    canClear,
    dateFormat = "dd/MM/yyyy",
    placeholder = "**/**/****",
    attention,
    attentionMsg,
    required,
    ...other
  } = props;

  let _date = !!selected ? new Date(selected) : null;
  let _selected = !isNaN(_date?.getTime()) ? _date : null;

  return (
    <>
      <Tooltip2 tip={attentionMsg}>
        <div
          className={style.datePicker}
          data-attention={!!attention}
          data-required={required}
          data-required-valid={required && !!_selected}
        >
          <ReactDatePicker
            className={style.datePicker}
            autoComplete="off"
            dateFormat={dateFormat}
            locale="pt"
            startDate={null}
            selected={_selected || ""}
            peekNextMonth
            showMonthDropdown
            showYearDropdown
            showMonthYearPicker={dateFormat === "MM/yyyy"}
            dropdownMode="select"
            placeholderText={placeholder}
            customInput={
              dateFormat === "HH:mm" ? (
                <PatternFormat format="##:##" placeholder="..." />
              ) : dateFormat === "MM/yyyy" ? (
                <PatternFormat format="##/####" placeholder="**/****" />
              ) : (
                <PatternFormat format="##/##/####" placeholder="..." />
              )
            }
            onChange={e => {
              changeDate(e);
            }}
            {...other}
          />
          {canClear && _selected && (
            <span
              className={style.clear}
              onClick={e => {
                changeDate("");
              }}
            >
              <IcX />
            </span>
          )}
        </div>
      </Tooltip2>
    </>
  );
}
